import { Type } from '@angular/core';

import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';

export enum MediaTypeCollectionTypesEnum  {
    CORE_SOCIAL_MEDIA_TYPE_ONLY,
    SOCIAL_MEDIA_TYPES_ONLY,
    ALL
};

export class MediaTypeColorPickerWrapperFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    mediaTypeCollectionType: MediaTypeCollectionTypesEnum;
    headingId?: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        mediaTypeCollectionType: MediaTypeCollectionTypesEnum,
        headingId?: string
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.mediaTypeCollectionType = mediaTypeCollectionType;
        this.headingId = headingId;
    }
}
